import { BotType } from '../types'
import { isPreviousMIAWSession } from './getPreviousMIAWSession'

const BOT_TYPE = 'chatBotType'

export const getBotType = () => localStorage.getItem(BOT_TYPE)
export const setBotType = (botType: string) => localStorage.setItem(BOT_TYPE, botType)
export const clearBotType = () => {
  localStorage.removeItem(BOT_TYPE)
  const event = new Event('storage')
  window.dispatchEvent(event)
}

export const getLoadType = ({
  isAgentForcePage,
  isDefaultMIAWPage,
}: {
  isAgentForcePage: boolean
  isDefaultMIAWPage: boolean
}) => {
  const isMIAWSession = isPreviousMIAWSession()
  if (isMIAWSession) {
    const chatBotType = getBotType()
    return chatBotType === BotType.AGENT_FORCE ? BotType.AGENT_FORCE : BotType.DEFAULT
  }

  if (isAgentForcePage) return BotType.AGENT_FORCE
  if (isDefaultMIAWPage) return BotType.DEFAULT
  return BotType.LIVE_CHAT
}
